import React, { createContext, useContext, ReactNode } from 'react'

export const ViewContext = createContext<unknown>({})

export const useViewContext = <T = unknown,>() => {
  return useContext(ViewContext) as T
}

interface ViewProviderProps<T> {
  value: T
  children: ReactNode
}

// Provider component
export const ViewProvider = <T,>({ children, value }: ViewProviderProps<T>): React.ReactElement => {
  return <ViewContext.Provider value={value}>{children}</ViewContext.Provider>
}
